import React, { useState } from 'react';
import OptionsAndOther from '../../choose_an_option';

export default function AsmSideEffect({ answers, onSubmit, onBack, gtm, showBack }) {
  return (
    <div className={`row activity-question`}>
      <div className='col-sm-2'></div>
      <div className='col-sm-8'>
        <OptionsAndOther
          answers={{ xcopriAsmSideEffect: answers.xcopriAsmSideEffect }}
          onSubmit={(newAnswers) =>
            onSubmit({ ...answers, xcopriAsmSideEffect: newAnswers.xcopriAsmSideEffect, other: newAnswers.other })
          }
          onBack={onBack}
          title={`What side effects (if any) are you (or the patient) experiencing with the current anti-seizure medication (ASM)? (Please check all that apply.)`}
          keyForAnswer={`xcopriAsmSideEffect`}
          choices={['Dizziness', 'Headache', 'Feeling anxious or worried', 'Sleepiness', 'Behavior changes']}
          selectOne={false}
          showOther={true}
          otherTxt={`Other side effects`}
          showBack={showBack}
        />
      </div>
      <div className='col-sm-2'></div>
    </div>
  );
}
